<ng-container *ngIf="contractRequestProductType === 'LOC'">
  <div class="contract-request-value">
    <span class="tw-font-bold">Lender:</span> {{ deal?.loan_product_lender.name || '' }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Product Type:</span> {{ deal?.loan_product.category.shortName || '' }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Initial Draw Amount:</span> {{ contract_request.terms?.initialDrawAmount }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Credit Limit:</span> {{ contract_request.terms?.creditLimit }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Term:</span> {{ contract_request.terms?.term }} {{ contract_request.terms?.termType }}
  </div>
  <div *ngIf="contract_request.terms?.points" class="contract-request-value">
    <span class="tw-font-bold">Points:</span> {{ contract_request.terms?.points | number }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Payment Frequency:</span> {{ paymentFrequencyOptionNames[contract_request.terms?.paymentFrequency] }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Business Owner Email(s):</span> {{ signersFormatted }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Best Number for Funding Call:</span> {{ contract_request?.fundingCallPhone }}
  </div>
</ng-container>
<ng-container *ngIf="contractRequestProductType === 'TERM'">
  <div class="contract-request-value">
    <span class="tw-font-bold">Lender:</span> {{ deal?.loan_product_lender.name || '' }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Product Type:</span> {{ deal?.loan_product.category.shortName || '' }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Loan Amount:</span> {{ contract_request.terms?.amount }}
  </div>
  <div *ngIf="contract_request.terms?.originationFeeAmount" class="contract-request-value">
    <span class="tw-font-bold">Origination Fee:</span> {{ contract_request.terms?.originationFeeAmount }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Term:</span> {{ contract_request.terms?.term }} {{ contract_request.terms?.termType }}
  </div>
  <div *ngIf="contract_request.terms?.points" class="contract-request-value">
    <span class="tw-font-bold">Points:</span> {{ contract_request.terms?.points | number }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Payment Frequency:</span> {{ paymentFrequencyOptionNames[contract_request.terms?.paymentFrequency] }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Business Owner Email(s):</span> {{ signersFormatted }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Best Number for Funding Call:</span> {{ contract_request?.fundingCallPhone }}
  </div>
</ng-container>
<ng-container *ngIf="contractRequestProductType === 'ACH'">
  <div class="contract-request-value">
    <span class="tw-font-bold">Lender:</span> {{ deal?.loan_product_lender.name || '' }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Product Type:</span> {{ deal?.loan_product.category.shortName || '' }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Loan Amount:</span> {{ contract_request.terms?.amount }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Term:</span> {{ contract_request.terms?.term }} {{ contract_request.terms?.termType }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Points:</span> {{ contract_request.terms?.points | number }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Factor Rate:</span> {{ contract_request.terms?.factorRate | number }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Payment Frequency:</span> {{ paymentFrequencyOptionNames[contract_request.terms?.paymentFrequency] }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Business Owner Email(s):</span> {{ signersFormatted }}
  </div>
  <div class="contract-request-value">
    <span class="tw-font-bold">Best Number for Funding Call:</span> {{ contract_request?.fundingCallPhone }}
  </div>
</ng-container>
<div class="tw-pt-2">
  <div class="tw-grid tw-grid-flow-col">
    <div class="tw-font-bold tw-flex tw-items-center">Note For Lender:</div>
    <div class="tw-text-right">
      <button
        *ngIf="canEditContractRequests"
        type="button"
        mat-button
        color="primary"
        [disabled]="sending"
        (click)="edit()"
      >
        {{ contract_request.noteForLender ? 'Edit Note' : 'Add Note' }}
      </button>
    </div>
  </div>
  <span>{{ contract_request.noteForLender }}</span>
</div>
